import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import App from "App";
import { SoftUIControllerProvider } from "context";
import { Toaster } from "react-hot-toast";
import store from "./api/store";
import { Provider } from "react-redux";
import GoogleMapsProvider from "components/location/googleMapProvider";

ReactDOM.render(
  <BrowserRouter>
    {/* <GoogleMapsProvider> */}
      <Provider store={store}>
    <SoftUIControllerProvider>
    <div><Toaster /></div>
      <App />
    </SoftUIControllerProvider>
    </Provider>
      {/* </GoogleMapsProvider> */}
  </BrowserRouter>,
  document.getElementById("root")
);
